export default
{
  adblock: 'Hola! Este sitio es transparente y le permite elegir los servicios de terceros que desea permitir.',
  adblock_call: 'Por favor, desactive su adblocker para empezar a personalizar.',
  reload: 'Actualizar la página',

  alertDisclaimerTitle: 'Su privacidad es nuestra prioridad',
  alertDisclaimer: 'Al continuar su navegación, usted acepta el uso de cookies por nuestra parte y por parte de nuestros socios para proporcionar contenido y ofertas adaptadas a sus intereses, publicidad personalizada y análisis de tráfico..',
  alertDisclaimerText: '<p>Cuando usted visita este sitio, nosotros y nuestros socios podemos depositar, de forma independiente o conjunta, cookies y tecnologías similares para recopilar información, incluyendo datos personales, tales como: dirección IP, identificadores únicos, datos de navegación, datos de geolocalización. </p><p>Estos datos son tratados por nosotros y/o nuestros socios, incluidos los socios publicitarios, con los siguientes fines: analizar y mejorar la experiencia del usuario, almacenar y/o acceder a información sobre un terminal, medir y analizar la audiencia, interactuar con las redes sociales, luchar contra el fraude, mostrar anuncios y contenidos personalizados, medir el rendimiento de los anuncios y contenidos.</p><p>Con la excepción de los necesarios para el funcionamiento del sitio, así como, en determinadas condiciones, para la medición de la audiencia, las cookies y tecnologías similares sólo pueden depositarse con su consentimiento. Usted puede dar, rechazar o retirar libremente su consentimiento en cualquier momento accediendo a nuestra herramienta de configuración de cookies. Si no consiente el uso de estas tecnologías, consideraremos que también se opone a cualquier depósito de cookies que algunos socios justifiquen por un interés legítimo.</p>',
  alertBigScroll: 'Si continúa desplazándose por la pantalla,',
  alertBigClick: 'Si continúa navegando por este sitio web,',
  alertBig: 'está permitiendo que todos los servicios de terceros',

  alertBigPrivacy: 'Este sitio utiliza cookies y le da control sobre lo que desea activar.',
  alertSmall: 'Gestionar servicios',
  acceptAll: 'OK, acepte todos',
  personalize: 'Más información y configuración',
  close: '&times;',
  closeTitle: 'Cerrar la ventana',

  privacyUrl: 'Política de privacidad',

  all: 'Preferencia por todos los servicios',

  info: 'Protegiendo su privacidad',
  disclaimer: 'Al permitir estos servicios de terceros, usted acepta sus cookies y el uso de tecnologías de seguimiento necesarias para su correcto funcionamiento.',
  allow: 'Permitir',
  deny: 'Renegar',
  noCookie: 'Este servicio no utiliza cookies.',
  useCookie: 'Este servicio puede instalar',
  useCookieCurrent: 'Este servicio tiene instalado',
  useNoCookie: 'Este servicio no ha instalado ninguna cookie.',
  more: 'Leer más',
  source: 'Ver el sitio web oficial',
  credit: 'Gestor de cookies de Nematis',

  toggleInfoBox: 'Mostrar/ocultar información sobre el almacenamiento de cookies',
  title: 'Administración de sus preferencias de cookies',
  cookieDetail: 'Detalle de las cookies para',
  ourSite: 'en nuestra página web',
  newWindow: '(nueva ventana)',
  accept: 'Acepto',
  allowAll: 'Permitir todas las cookies',
  denyAll: 'Denegar todas las cookies',

  fallback: 'está desactivado.',

  disabled_content: '%service% está desactivado. Autorizar el depósito de cookies par acceder al contenido.',
  disabled_video: '%service% está desactivado. Autorizar el depósito de cookies par reproducir el vídeo.',

  technical: {
    title: 'Galletas técnicas',
    details: ''
  },
  ads: {
    title: 'Red de publicidad',
    details: 'Las redes publicitarias pueden generar ingresos vendiendo espacio publicitario en el sitio..'
  },
  analytic: {
    title: 'Medición de audiencias',
    details: 'Los servicios de medición de audiencia utilizados para generar estadísticas de asistencia útiles para mejorar el sitio..'
  },
  social: {
    title: 'Redes sociales',
    details: 'Las redes sociales pueden mejorar la usabilidad del sitio y ayudar a promocionarlo a través de las acciones.'
  },
  video: {
    title: 'Vídeos',
    details: 'Los servicios de compartición de vídeo ayudan a añadir medios con tecnología avanzada en el sitio y a aumentar su visibilidad.'
  },
  comment: {
    title: 'Comentarios',
    details: 'Los gestores de comentarios facilitan la presentación de comentarios y luchan contra el spam.'
  },
  support: {
    title: 'Soporte técnico',
    details: 'Los servicios de apoyo le permiten ponerse en contacto con el equipo del sitio y ayudar a mejorarlo.'
  },
  api: {
    title: 'APIs',
    details: 'Las APIs se utilizan para cargar scripts : geolocalización, buscadores, traducciones, ...'
  },
  other: {
    title: 'Otros',
    details: 'Servicios de visualización de contenidos web.'
  }
}
